/**
 * OOTB SFRA JS code
 * DRP-453 implemented productTileSwatch
 */

'use strict';

var processInclude = require('base/util');

import detail from './product/detail';

$(document).ready(function () {
    processInclude(require('./search/search'));
    processInclude(require('./search/productGrid'));
    processInclude(require('./search/sortOrderMenu'));
    processInclude(require('./components/selectStore'));

    // logic used for highlight-modules
    processInclude(detail.addToCart);
    processInclude(detail.selectPdpSizeAttribute);
});

processInclude(require('./pGiftCardQuickView'));
